import * as React from 'react';
import { WarningWithConfirmation } from '../../../atoms/membership_plans/WarningWithConfirmation';
import { SpBr } from '../../../../../commonv3/components/atoms/layouts/br';

export const LessonDeactivationWarning = ({ confirmed, onConfirmationChange }) => (
  <WarningWithConfirmation
    id="deactivation-confirmation"
    header={
      <span>
        受け放題プランから月5回プランへの
        <SpBr />
        変更をされる場合の注意点
      </span>
    }
    body={
      <span>
        ※ 受け放題プランから月5回プランへの変更の場合、過去受講した履歴はリセットされます。
        <br />※ 受け放題プラン受講時に視聴した動画を視聴する場合、月５回のうちの1回を消費します。
      </span>
    }
    confirmed={confirmed}
    onConfirmationChange={onConfirmationChange}
  />
);
